import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectenvironmentsQueryItems } from '../../../../../redux/environments/selector';
import { environments } from '../../../../../redux/environments/action';
import EnvironmentComponent from '../components/environment-component';

let currentChange: any = {}
const Environment= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectenvironmentsQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  
  
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedEnvironment,
    setSelectedEnvironment
  ] = useState<any>({
    MediaMappings: {
      MediaFiles: [],
      Templates: []
    }
  })
  const [
    environmentImageIndex,
    setEnvironmentImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
 
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  const fetchEnvironmentById= ()=>{
    dispatch(environments.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/environments/query`,entity:'environments',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedEnvironment({ ...selectedEnvironment, [field]: event });
  }

  useEffect(
    () => {
     
      if (parmas?.id > 0) {
        fetchEnvironmentById()
        setIsLoading(false)
    }else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedEnvironment(queryItems?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();

    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
      const updatedData = {
        ...selectedEnvironment,
        MediaMappings: {MediaFiles: mediaFiles, Templates: selectedEnvironment?.MediaMappings?.Templates},
    };
    if (parmas?.id > 0) {
      await dispatch(environments.resetAction({ actionType: 'update' }))
     await dispatch(environments.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/environments`,entity:'environments',jsonData:{
          
    Records: [
      updatedData
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(environments.resetAction({ actionType: 'create' }))
      await dispatch(environments.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/environments`,entity:'environments',jsonData:{
          
      Records: [
        updatedData
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/dbaas/environments')
} 
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 143,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setEnvironmentImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'environment',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[environmentImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
  
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )
  
    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />}
    {isLoading ? <PageLoader /> : 
          <EnvironmentComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedEnvironment={selectedEnvironment}
           back={back}
           handleFormSubmit={handleFormSubmit}
           changeImage={changeImage}
           mediaFiles={mediaFiles}
           handleFormItemChange={handleFormItemChange}

          />  
        }
    
          </>
    )
    
    }
   
    export default Environment;
